var path = '/pages/guestlists/views/pages/rsvps/list.tpl.html';
var html = "<div class=\"content-box\" ng-if=\"vm.loading\">\n    <al-loader size=\"medium\"></al-loader>\n</div>\n<div ng-if=\"!vm.loading && vm.store\">\n    <listview store=\"vm.store\" ng-if=\"vm.mode === 'listview'\"></listview>\n    <ng-include src=\"vm.editorTemplate\" ng-if=\"vm.mode === 'editor'\"></ng-include>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/guestlists/views/pages/rsvps/list.tpl.html
// module id = 2286
// module chunks = 1